/**
 * Warns about unhandled XState events via `console.warn`. Add as a `'*'`
 * wildcard handler at the root of each machine.
 */
export function warnUnhandledEvent(machineId: string, eventType: string): void {
  console.warn(`[${machineId}] Unhandled event: ${eventType}\n`, new Error().stack);
}
